<template>
  <div
    class="block-accordion-text"
    :class="{ 'is-on-grid': isOnGrid }"
  >
    <div class="block-accordion-text__inner">
      <AtomTextHeading
        v-if="title"
        html-tag="h3"
        font-size="h3"
        class="block-accordion-text__title"
        :text="title"
      />

      <div class="block-accordion-text__accordion">
        <BlockAccordionTextEntry
          v-for="(entry, index) of entries"
          :key="`accordion-${componentUid}-${index}`"
          v-bind="entry"
          :accent-color="accentColor"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
    /* Layout */
    isOnGrid: {
        type: Boolean,
        default: false,
    },

    /* Styles */
    accentColor: {
        type: String,
        default: 'var(--c-primary)',
    },

    /* Content */
    title: {
        type: String,
        default: '',
    },

    entries: {
        type: Array,
        default: () => [],
    },
});

const componentUid = getUid();
</script>

<style lang="scss" scoped>
.block-accordion-text {
    &.is-on-grid {
        @include wrapper-layout();
        @include grid-layout();
        margin-bottom: var(--m-bottom--medium);
    }
}

.block-accordion-text__inner {
    @include default-content-columns('wide');
    @include box-default('small');
}

.block-accordion-text__accordion {
    display: flex;
    flex-direction: column;
}

.block-accordion-text__title {
    margin-bottom: 20px;
}
</style>
